import React, { Component, Fragment } from 'react'
import { NavLink as Link, withRouter } from 'react-router-dom';
import {Navbar, NavbarToggler, Collapse, Nav, NavLink} from 'reactstrap';

const fr = {
  'links': [
    { id:1, name: "Accueil", link: "/accueil"},
    { id:2, name: "Kinésitherapeutes", link: "/kinesitherapeute"},
    { id:3, name: "Rendez-vous", link: "/rendez-vous"},
    { id:4, name: "Accès", link: "/acces"},
    { id:5, name: "Faq", link: "/faq"}
  ]
};

const ndls = {
  'links': [
    { id:1, name: "Home", link: "/accueil"},
    { id:2, name: "Therapeuten", link: "/kinesitherapeute"},
    { id:3, name: "Contact", link: "/rendez-vous"},
    { id:4, name: "Bereikbaarheid", link: "/acces"},
    { id:5, name: "Faq", link: "/faq"}
  ]
};

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.toggleOpenState = this.toggleOpenState.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggleOpenState() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  switchLanguage(){
    const newLang = this.props.lang === 'fr' ? 'ndls' : 'fr';
    this.props.switchLang(newLang);
  }

  renderLang() {
    if (this.props.lang === 'fr') {
      return <button style={{cursor:"pointer"}} className="languageBtn btn btn-responsive" onClick={this.switchLanguage.bind(this)}>Ndls</button>
    }
    else {
      return <button style={{cursor:"pointer"}} className="languageBtn btn btn-responsive" onClick={this.switchLanguage.bind(this)}>Fr</button>
    }
  }
/*

*/
  render() {
        let navData = this.props.lang === "fr" ? fr : ndls;
        let banner = this.props.lang === "fr" ? "logoFR" : "logoNDLS";
        return (
            <Fragment>
              <header>
              <div className="img-wrapper">
                <img className="img-responsive" alt="Kiné Vertriest" src={"/Images/" + banner + ".png"} />
                <div className="img-overlay">
                  {
                      this.renderLang()
                  }
                </div>
              </div>
              </header>
              <Navbar expand="md" light className="shadow rounded">
          		  <NavbarToggler onClick={this.toggleOpenState} />
          		  <Collapse isOpen={this.state.isOpen} navbar>
                  <Nav className="mx-auto" navbar>
                    { navData['links'].map((x)=>
                      <NavLink key={x.id} tag={Link} to={x.link} className='px-3' >{x.name}</NavLink>
                    )}
                  </Nav>
                </Collapse>
              </Navbar>
            </Fragment>
        )
    }
}

export default withRouter(Navigation)
